$('.image-comparator .img-container > div img').on('click', function () {
  window.open(`${window.Shopify.routes.root.slice(0, -1)}${$(this).closest('.img-container').find('a').attr('href')}`, '_blank');
})

function initImageComparator (selector, options = {}) {
  // 合并默认配置
  const config = {
    initialPosition: 0.5, // 初始位置比例 (0-1)
    handleClass: 'handle',
    imgAfterClass: 'img-after',
    ...options
  };

  const $comparator = $(selector);
  const $handle = $comparator.find('.' + config.handleClass);
  const $imgAfter = $comparator.find('.' + config.imgAfterClass);

  let isDragging = false;
  let comparatorWidth = $comparator.width();

  // 初始化位置
  function initPosition () {
    const handlePos = comparatorWidth * config.initialPosition;
    $handle.css('left', handlePos);
    updateClipPath(handlePos);
  }

  // 更新裁剪区域
  function updateClipPath (position) {
    const clipX = (position / comparatorWidth) * 100;
    $imgAfter.css('clip-path', `polygon(0 0, ${clipX}% 0, ${clipX}% 100%, 0 100%)`);
  }

  // 事件处理函数
  function handleMouseDown (e) {
    isDragging = true;
    $('body').css('cursor', 'ew-resize');
    e.preventDefault();
  }

  function handleMouseMove (e) {
    if (!isDragging) return;
    updatePosition(e.clientX);
  }

  function handleMouseUp () {
    isDragging = false;
    $('body').css('cursor', '');
  }

  function handleTouchStart (e) {
    isDragging = true;
    e.preventDefault();
  }

  function handleTouchMove (e) {
    if (!isDragging) return;
    const touch = e.originalEvent.touches[0];
    updatePosition(touch.clientX);
  }

  function handleTouchEnd () {
    isDragging = false;
  }

  function updatePosition (mouseX) {
    const comparatorRect = $comparator[0].getBoundingClientRect();
    const offsetX = mouseX - comparatorRect.left;
    let newPos = Math.max(0, Math.min(offsetX, comparatorWidth));

    if (newPos >= 20 && newPos <= comparatorWidth - 20 - $handle.width()) {
      $handle.css('left', newPos);
      updateClipPath(newPos);
    }
  }

  // 绑定事件
  $handle.on('mousedown', handleMouseDown);
  $(document).on('mousemove', handleMouseMove);
  $(document).on('mouseup', handleMouseUp);

  $handle.on('touchstart', handleTouchStart);
  $(document).on('touchmove', handleTouchMove);
  $(document).on('touchend', handleTouchEnd);

  // 窗口大小变化时重新初始化
  $(window).on('resize', function () {
    comparatorWidth = $comparator.width();
    initPosition();
  });

  // 初始化
  initPosition();

  // 返回销毁函数
  return function destroy () {
    $handle.off('mousedown', handleMouseDown);
    $(document).off('mousemove', handleMouseMove);
    $(document).off('mouseup', handleMouseUp);
    $handle.off('touchstart', handleTouchStart);
    $(document).off('touchmove', handleTouchMove);
    $(document).off('touchend', handleTouchEnd);
    $(window).off('resize');
  };
}

$.each($('.image-comparator'), function (i, item) {
  initImageComparator(`.image-comparator:nth-of-type(${i + 1})`, {
    handleClass: 'handle',
    imgAfterClass: 'img-after'
  });
});